/** Shared billing helpers — parity with mobile src/lib/billing.ts */
export const PENDING_TIER_KEY = "pg_pending_tier";
export const PENDING_PERIOD_KEY = "pg_pending_period";
export const ANNUAL_MONTHS_CHARGED = 10;

export const TIER_META = {
  basic: { name: "Basic", price: 20, tagline: "Solo mechanic starter" },
  pro: { name: "Pro", price: 30, tagline: "Growing independent garage" },
  premium: { name: "Premium", price: 50, tagline: "Multi-tech workshop" },
};

export function displayPrice(tier, period) {
  const monthly = TIER_META[tier].price;
  return period === "annual" ? monthly * ANNUAL_MONTHS_CHARGED : monthly;
}

export function pricePer(period) {
  return period === "annual" ? "/yr" : "/mo";
}

export function savePendingSelection(tier, period) {
  localStorage.setItem(PENDING_TIER_KEY, tier);
  localStorage.setItem(PENDING_PERIOD_KEY, period);
}

export function readPendingSelection() {
  const t = localStorage.getItem(PENDING_TIER_KEY) || "";
  const p = localStorage.getItem(PENDING_PERIOD_KEY) || "monthly";
  const tier = t === "basic" || t === "pro" || t === "premium" ? t : null;
  const period = p === "annual" ? "annual" : "monthly";
  return { tier, period };
}

export function clearPendingSelection() {
  localStorage.removeItem(PENDING_TIER_KEY);
  localStorage.removeItem(PENDING_PERIOD_KEY);
}

export function formatSubStatus(status) {
  switch (status) {
    case "active":
      return { label: "ACTIVE", tone: "success" };
    case "trialing":
      return { label: "TRIAL", tone: "info" };
    case "past_due":
      return { label: "PAST DUE", tone: "warn" };
    case "unpaid":
      return { label: "UNPAID", tone: "warn" };
    case "canceled":
      return { label: "CANCELED", tone: "error" };
    case "incomplete":
    case "incomplete_expired":
      return { label: "INCOMPLETE", tone: "warn" };
    default:
      return { label: "NO PLAN", tone: "info" };
  }
}

/** Status chip colour map (parity with mobile theme.ts statusColor) */
export const statusColor = {
  open: { bg: "#E2E8F0", fg: "#334155", label: "OPEN" },
  in_progress: { bg: "#EFF6FF", fg: "#1D4ED8", label: "IN PROGRESS" },
  awaiting_parts: { bg: "#FEF3C7", fg: "#B45309", label: "AWAITING PARTS" },
  completed: { bg: "#D1FAE5", fg: "#065F46", label: "COMPLETED" },
  invoiced: { bg: "#E2E8F0", fg: "#0B1F3A", label: "INVOICED" },
  paid: { bg: "#D1FAE5", fg: "#065F46", label: "PAID" },
  partial: { bg: "#FEF3C7", fg: "#B45309", label: "PARTIALLY PAID" },
  unpaid: { bg: "#E2E8F0", fg: "#64748B", label: "UNPAID" },
  overdue: { bg: "#FEE2E2", fg: "#B91C1C", label: "OVERDUE" },
  void: { bg: "#E2E8F0", fg: "#94A3B8", label: "VOID" },
  coming_soon: { bg: "#EFF6FF", fg: "#1D4ED8", label: "COMING SOON" },
  booked: { bg: "#E0F2F1", fg: "#0F766E", label: "BOOKED" },
  pending: { bg: "#FEF3C7", fg: "#B45309", label: "PENDING" },
  declined: { bg: "#FEE2E2", fg: "#B91C1C", label: "DECLINED" },
  cancelled: { bg: "#E2E8F0", fg: "#94A3B8", label: "CANCELLED" },
};
